module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1033-a446e89c6e2458a5ca5dd78a4b0471bb.png";